__webpack_require__.p = "/Prachayika/";